export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';
export const THEME_SOLID = 'solid';
